module.exports = "<app-print></app-print>\n"